function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.1 14.442V3.909c0-.502.403-.909.9-.909s.9.407.9.91v10.532l2.064-2.085a.894.894 0 011.272 0 .916.916 0 010 1.286l-3.6 3.636a.894.894 0 01-1.272 0l-3.6-3.636a.916.916 0 010-1.286.894.894 0 011.272 0l2.064 2.085zM3 17.545c0-.502.403-.909.9-.909s.9.407.9.91v2.727c0 .502.403.909.9.909h12.6c.497 0 .9-.407.9-.91v-2.727c0-.502.403-.909.9-.909s.9.407.9.91v2.727C21 21.779 19.791 23 18.3 23H5.7C4.209 23 3 21.779 3 20.273v-2.728z"
});

var SvgDownload = function SvgDownload(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/download.8530c701.svg";
export { SvgDownload as ReactComponent };